module.exports = __webpack_public_path__ + "img/3.73d3d1df.svg";